var map = {
	"./1-Sukanya Chandra - State In charge Andhra Pradesh.jpeg": 2759,
	"./2- Mr. K.M.K Ramesh- North Andhra In charge.jpeg": 31660,
	"./3- Mr. K. Pruthvi Raj-Visakhapatnam Incharge.jpeg": 77477
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32284;